<template>
  <v-select
    :options="options"
    :reduce="option => option.value"
    :value="value"
    @input="setValue"
    :placeholder="$t('selects.zoneSelectPlaceholder')"
    :multiple="false"
    :disabled="disabled"
  />
</template>

<script>
export default {
  name: 'ReportingZoneSelect',
  props: {
    value: { type: String },
    zones: { type: Array, default: () => [] },
    disabled: { type: Boolean, default: false },
  },
  computed: {
    options() {
      const mapped = this.zones?.map(zone => ({
        value: zone.uuid,
        label: zone.name,
      }))
      const sorted = mapped?.sort((a, b) => a.label.localeCompare(b.label, this.$i18n.locale, { sensitivity: 'base' }))
      return sorted
    },
  },
  methods: {
    setValue(value) {
      this.$emit('input', value)
    },
  },
}
</script>
